import { useEffect } from 'react';
import { getEcho, leaveChannel } from '../lib/echo';
import { useAuth } from '../hooks/useAuth';
import { useOnlineStatusStore } from '../stores/useOnlineStatusStore';

/**
 * Presence (`online`) kanalına abone olup çevrim içi kullanıcı set'ini
 * `useOnlineStatusStore`'a yazar. Artık context sağlamaz; tüketiciler
 * store'u doğrudan (tercihen selector ile) okur.
 */
export function OnlineStatusProvider({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();

  useEffect(() => {
    if (!user) return;
    const echo = getEcho();
    if (!echo) return;

    const store = useOnlineStatusStore.getState();

    const channel = echo.join('online');
    channel
      .here((members: { id: number }[]) => {
        store.setOnlineUserIds(new Set(members.map((m) => m.id)));
      })
      .joining((member: { id: number }) => {
        store.addOnlineUser(member.id);
      })
      .leaving((member: { id: number }) => {
        store.removeOnlineUser(member.id);
      })
      .listen('.user.status.changed', (e: { user_id: number; is_online: boolean }) => {
        if (e.is_online) store.addOnlineUser(e.user_id);
        else store.removeOnlineUser(e.user_id);
      });

    return () => {
      leaveChannel('online');
      store.setOnlineUserIds(new Set());
    };
  }, [user]);

  return <>{children}</>;
}
